import { gql } from '@urql/core';

import { defaultMutationFuction } from '../../graphql/defaultMutationFuction';

export const setEnabledGaProperties = ({ client }) => ({
  mutationFn: ({ propertyIds }) =>
    defaultMutationFuction(
      client,
      gql`
        mutation SetEnabledGaProperties($propertyIds: [Int!]!) {
          setEnabledGaProperties(propertyIds: $propertyIds) {
            id
          }
        }
      `,
      {
        propertyIds,
      },
    ),
});
